import { useTranslation } from "@/core/i18n";
import { Button } from "atoms/button/Button";
import { Icon } from "atoms/icon/Icon";
import MediaCamera from "atoms/icon/icons/media_camera.svg";

type Props = {
  onRetry: () => void;
};

export const CameraPermissionRequired = ({ onRetry }: Props) => {
  const { t } = useTranslation();
  return (
    <div className="flex h-full w-full flex-col items-center justify-center bg-[#F7F8F9] px-4">
      <div className="flex flex-col items-center gap-6">
        <div className="relative">
          <div className="flex h-32 w-32 items-center justify-center rounded-full bg-[#E0F2F1]">
            <Icon svg={MediaCamera} size="x3large" color="brandColor" />
          </div>
        </div>

        <h2 className="text-center font-serif text-h2">{t("cameraPermissionRequired.title")}</h2>

        <p className="max-w-sm text-center text-body1">
          {t("cameraPermissionRequired.description")}
        </p>

        <div className="max-w-sm rounded-lg bg-white p-4 shadow-sm">
          <p className="mb-3 text-center text-bold2 text-primary">
            {t("cameraPermissionRequired.howToTitle")}
          </p>
          <ul className="space-y-2 text-body2 text-secondary">
            <li className="flex items-start gap-2">
              <span className="text-brandColor font-bold">1.</span>
              <span>{t("cameraPermissionRequired.step1")}</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-brandColor font-bold">2.</span>
              <span>{t("cameraPermissionRequired.step2")}</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-brandColor font-bold">3.</span>
              <span>{t("cameraPermissionRequired.step3")}</span>
            </li>
          </ul>
        </div>

        <Button onClick={onRetry} style="primary" size="large" fullWidth>
          {t("cameraPermissionRequired.tryAgain")}
        </Button>
      </div>
    </div>
  );
};
